import type { TFunction } from "i18next";
import { u2000BuildAppRouteHref } from "../../../../../u2000Core/tools/u2000OpenAppRouteInNewTab";
import { u3125FormatCurrency } from "../../../../../u3125Facture/U3125";
import { NS } from "../../../../U3121";
import type { U3121BillingSummary } from "../../../../U3121Service";
import U3121BillingSummaryMetricCard from "./U3121BillingSummaryMetricCard";
import U3121BillingSummaryNoAccessPanel from "./U3121BillingSummaryNoAccessPanel";

interface U3121BillingSummaryTimesheetsSectionProps {
  summary: U3121BillingSummary;
  onOpenDetail: () => void;
  t: TFunction;
}

function U3121BillingSummaryTimesheetsSection({ summary, onOpenDetail, t }: U3121BillingSummaryTimesheetsSectionProps) {
  if (summary.unapprovedTimesheets == null) {
    return (
      <section className="space-y-3">
        <h3 className="text-base font-semibold text-foreground">{t("sectionBillingSummaryTimesheets", { ns: NS })}</h3>
        <U3121BillingSummaryNoAccessPanel messageKey="msgBillingSummaryNoTimesheetAccess" t={t} />
      </section>
    );
  }

  const ts = summary.unapprovedTimesheets;

  return (
    <section className="flex h-full min-h-0 flex-col gap-3">
      <div className="flex shrink-0 flex-wrap items-center justify-between gap-2">
        <h3 className="text-base font-semibold text-foreground">{t("sectionBillingSummaryTimesheets", { ns: NS })}</h3>
        <a
          href={u2000BuildAppRouteHref("/U3129")}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-primary-600 hover:underline"
        >
          {t("btnGoToTimesheets", { ns: NS })}
        </a>
      </div>
      <div className="flex min-h-0 flex-1 flex-col">
        <U3121BillingSummaryMetricCard
          title={t("lblUnapprovedTimesheets", { ns: NS })}
          metrics={[
            { label: t("lblTimesheetCount", { ns: NS }), value: ts.count },
            { label: t("lblTotalReportedHours", { ns: NS }), value: ts.totalReportedHours },
            { label: t("lblTotalExpenseAmount", { ns: NS }), value: u3125FormatCurrency(ts.totalExpenseAmount) },
            { label: t("lblTotalEquipmentAmount", { ns: NS }), value: u3125FormatCurrency(ts.totalEquipmentAmount) },
          ]}
          onViewDetail={onOpenDetail}
          t={t}
        />
      </div>
    </section>
  );
}

export default U3121BillingSummaryTimesheetsSection;
